import { Link, LinkProps } from '@hover/blueprint';
import { chakra, CSSObject } from '@hover/blueprint/chakra';
import { motion, colors } from '@hover/blueprint/foundation';
import { GatsbyLinkProps, Link as GatsbyLink } from 'gatsby';
import { position, transitions, transparentize } from 'polished';
import React, { FunctionComponent } from 'react';

interface HeaderLinkProps extends LinkProps {
  isLight?: boolean;
  isGatsbyLink?: boolean;
  to?: GatsbyLinkProps<{}>['to'];
  titleColor?: string;
}

const NavbarLink: FunctionComponent<HeaderLinkProps> = ({
  isLight = false,
  isGatsbyLink = false,
  to,
  children,
  titleColor,
  ...props
}) => {
  let color: string;

  if (titleColor) {
    color = titleColor;
  } else {
    color = isLight ? 'neutral.0' : 'neutral.900';
  }

  const hover = isLight && !titleColor ? 'primary.200' : 'primary.600';

  const focus: CSSObject = {
    '&:before': {
      shadow: `0 0 0 1.5px ${
        isLight
          ? transparentize(0.75, colors.neutral[0])
          : colors.brandNavy[200]
      }`,
    },
  };

  return (
    <Link
      alignItems="center"
      as={isGatsbyLink ? GatsbyLink : 'button'}
      color={color}
      className="header-link"
      display="flex"
      height="100%"
      isMinimal
      size={500}
      to={to}
      {...props}
      _hover={{ color: hover }}
      _active={{ color: hover }}
      _before={{ shadow: 'none !important' }}
    >
      <chakra.div
        position="relative"
        _before={{
          borderRadius: '2px',
          boxShadow: 'invisibleNeutral',
          content: '""',
          ...position('absolute', '-2px', '-6px', '-2px', '-6px'),
          ...transitions(['box-shadow'], motion.easings[150]),
        }}
        sx={{
          // TODO(@jrolfs): replace with focus helper from @hover/blueprint
          '.header-link:focus &': focus,
          '.header-link:focus-visible &': focus,
          '.header-link:focus:not(:focus-visible) &': {
            '&:before': { shadow: 'none' },
          },
        }}
      >
        {children}
      </chakra.div>
    </Link>
  );
};

export default NavbarLink;
